import React, { useEffect, useState, Fragment, useRef } from "react";
import { PageHeader } from '../../../../Common';
import services from "../services";
import $ from "jquery";
import authService from "../../../Common/services";
import { LoadingSpinerComponent } from "../../../../Common/loader";
import { trackPromise } from "react-promise-tracker";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from "@material-ui/core/TextField";
import Joi, { x } from "@hapi/joi";
import { WeighmentDetailsReportSchemaObject } from "../WeighmentDetailsReportSchema";
import { validateProperty, validate } from "../../../Common";
import tokenService from "../../../../Common/tokenDecoder";
import ReactToPrint from "react-to-print";
import CreatePdf from './createPdf';
import '../../../Common/Table/table.css';
import xlsx from 'json-as-xlsx';
import _ from 'lodash';
import Box from '@material-ui/core/Box';
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import TablePagination from '@material-ui/core/TablePagination';
import Paper from '@material-ui/core/Paper';
import { TableRow } from "@material-ui/core";
import { makeStyles } from '@material-ui/core/styles';
import moment from "moment";
import tokenDecoder from '../../../../Common/tokenDecoder';
const screenCode = "WEIGHMENTDETAILSREPORT";

const useStyles = makeStyles({
    table: {
        minWidth: 650,
    },
    dialog1: {
        width: 850,
    },
    stickyHeader: {
        position: 'sticky',
        top: 0,
        zIndex: 1,
        backgroundColor: 'white',
    },
    stickyColumn: {
        position: 'sticky',
        left: 0,
        zIndex: 1,
        backgroundColor: 'white',
    },
});

export function WeighmentDetailsReport(props) {

    const componentRef = useRef();
    const classes = useStyles();
    const [limit, setLimit] = useState(10);
    const [page, setPage] = useState(0);
    const [groups, setGroups] = useState([]);
    const [factories, setFactories] = useState([]);
    const [routes, setRoutes] = useState([]);
    const [isTableHide, setIsTableHide] = useState(true);
    const date = new Date(); date.setDate(date.getDate() - 1);
    const [weighmentDetailsReport, setWeighmentDetailsReport] = useState({
        groupID: "0",
        factoryID: "0",
        routeID: "0",
        fromDate: date.toISOString().split("T")[0],
        toDate: date.toISOString().split("T")[0]
    });

    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "0",
        factory: "0",
        route: "0",
        fromDate: "",
        toDate: ""
    });

    const [errors, setErrors] = useState({});

    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false,
    });

    const schema = Joi.object(WeighmentDetailsReportSchemaObject).options({ allowUnknown: true });

    const csvHeaders = [
        { label: "Date", value: "date" },
        { label: "Route Name", value: "collectionPointName" },
        { label: "Registration Number", value: "registrationNumber" },
        { label: "Supplier Name", value: "firstName" },
        { label: "First Weighment Time", value: "startTime" },
        { label: "Last Weighment Time", value: "endTime" },
        { label: "Total", value: "totalAmount" }
    ]
    const [csvData, setCsvData] = useState([]);
    const [reportData, setReportData] = useState([]);
    const [totalAmount, setTotalAmount] = useState(0);

    const handleLimitChange = (event) => {
        setLimit(event.target.value);
    };
    const handlePageChange = (event, newPage) => {
        setPage(newPage);
    };

    useEffect(() => {
        trackPromise(getPermissions(),
            getGroupsForDropdown()
        );
    }, []);

    useEffect(() => {
        trackPromise(
            getFactoriesForDropdown(),
        )
    }, [weighmentDetailsReport.groupID])

    useEffect(() => {
        trackPromise(
            getRoutesForDropDown()
        )
    }, [weighmentDetailsReport.factoryID])

    function handleGroupChange(target) {
        validateInputs(target);

        setWeighmentDetailsReport({
            ...weighmentDetailsReport,
            groupID: target.value,
            factoryID: "0",
            routeID: "0"
        });
    }

    function handleFactoryChange(target) {
        validateInputs(target);

        setWeighmentDetailsReport({
            ...weighmentDetailsReport,
            factoryID: target.value,
            routeID: "0"
        });
    }

    function handleRouteChange(target) {
        validateInputs(target);

        setWeighmentDetailsReport({
            ...weighmentDetailsReport,
            routeID: target.value,
        });
    }

    function handleFromDateChange(target) {
        validateInputs(target);

        setWeighmentDetailsReport({
            ...weighmentDetailsReport,
            fromDate: target.value,
        });
    }

    function handleToDateChange(target) {
        validateInputs(target);

        setWeighmentDetailsReport({
            ...weighmentDetailsReport,
            toDate: target.value,
        });
    }

    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, WeighmentDetailsReportSchemaObject);
        errorMessage
            ? (error[target.name] = errorMessage)
            : delete error[target.name];

        setErrors(error);
    }


    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWWEIGHMENTDETAILSREPORT');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');


        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled:
                isOperationEntityFilterEnabled !== undefined,
        });
        var token = tokenService.getUserDetailsFromToken();

        setWeighmentDetailsReport({
            ...weighmentDetailsReport,
            groupID: token.groupID,
            factoryID: token.operationEntityID
        });
        trackPromise(getGroupsForDropdown());
    }


    async function getGroupsForDropdown() {
        const result = await services.getAlGroupsForDropdown();
        setGroups(result);
    }

    async function getFactoriesForDropdown() {
        const data = await services.getFactoriesByGroupID(weighmentDetailsReport.groupID);
        setFactories(data);
    }

    async function getRoutesForDropDown() {
        const data = await services.getAllRoutesByFactoryID(weighmentDetailsReport.factoryID);
        setRoutes(data);
    }


    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(
                    <MenuItem key={key} value={key}>
                        {value}
                    </MenuItem>
                );
            }
        }
        return items;
    }


    async function handleSearch(e) {

        e.preventDefault();
        setIsTableHide(true);

        const errorMessages = validate(schema, weighmentDetailsReport);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;

        getSelectedDropdownValuesForReport(weighmentDetailsReport);

        const result = await services.GetWeighmentDetailsReportDetails(weighmentDetailsReport);
        let totalAmount = 0;
        result.forEach(x => {
            totalAmount += x.totalAmount
            x.date = moment(x.date).format('YYYY-MM-DD')
        });
        setTotalAmount(totalAmount);
        setReportData(result);
        generateCsvTotalRow(result, totalAmount);
    }

    // function createDataTable() {
    //     $("#leafCollectionSummary").DataTable()
    // }

    function generateCsvTotalRow(data, totalValues) {
        var copyOfData = _.cloneDeep(data);

        var newTotalRow = {
            date: "Total",
            totalAmount: totalValues,
        };

        var newDetailRow = {
            date: "Date",
            collectionPointName: new Date().toLocaleString(),
            registrationNumber: "User",
            firstName: tokenDecoder.getUserNameFromToken()
        };

        copyOfData.push(newTotalRow);

        copyOfData.unshift({}, newDetailRow, {})

        setCsvData(copyOfData);
    }

    function createFile() {
        var settings = {
            sheetName: 'Weighment Details Report',
            fileName: 'WeighmentDetailsReport',
            writeOptions: {}
        };

        xlsx(csvHeaders, csvData, settings, true)
    }

    function onCancelClick() {
        clearState();
    }

    function clearState() {
        setWeighmentDetailsReport({
            ...weighmentDetailsReport,
            routeID: "0",
            fromDate: "",
            toDate: ""
        });
        setIsTableHide(true);
        setErrors("");
    }


    function getSelectedDropdownValuesForReport(searchForm) {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchForm.groupID],
            factory: factories[searchForm.factoryID],
            route: routes[searchForm.routeID],
            toDate: searchForm.toDate,
            fromDate: searchForm.fromDate,
        })
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">

                        <PageHeader
                            title="Weighment Details Report"
                            isButtonEnable={permissionList.isAddEditEnabled}
                        />
                        <div className="card-body">
                            <form
                                onSubmit={(e) => handleSearch(e)}
                                disabled={false}
                            >
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            name="groupID"
                                            value={weighmentDetailsReport.groupID}
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            onChange={(e) => handleGroupChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && (
                                            <FormHelperText error>{errors["groupID"]}</FormHelperText>
                                        )}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="factoryID">Factory *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="factoryID"
                                            id="factoryID"
                                            name="factoryID"
                                            value={weighmentDetailsReport.factoryID}
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            onChange={(e) => handleFactoryChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Factory--</MenuItem>
                                            {generateDropDownMenu(factories)}
                                        </Select>
                                        {errors["factoryID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["factoryID"]}</FormHelperText>)}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="">Route</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="routeID"
                                            id="routeID"
                                            name="routeID"
                                            value={weighmentDetailsReport.routeID}
                                            onChange={(e) => handleRouteChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Route--</MenuItem>
                                            {generateDropDownMenu(routes)}
                                        </Select>
                                        {errors["routeID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["routeID"]}</FormHelperText>)}
                                    </div>
                                </div>

                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="searchDate">From Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="fromDate"
                                            name="fromDate"
                                            type="date"
                                            onChange={(e) => handleFromDateChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            value={weighmentDetailsReport.fromDate}

                                        />
                                        {errors["searchDate"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["searchDate"]}</FormHelperText>)}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="searchDate">To Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="toDate"
                                            name="toDate"
                                            type="date"
                                            onChange={(e) => handleToDateChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            value={weighmentDetailsReport.toDate}

                                        />
                                        {errors["searchDate"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["searchDate"]}</FormHelperText>)}
                                    </div>
                                </div>

                                <div className="card-footer">
                                    <input
                                        disabled={validate(schema, weighmentDetailsReport)}
                                        type="button"
                                        className="btn btn-primary"
                                        value="Search"
                                        onClick={e => trackPromise(handleSearch(e))}
                                    />

                                    <input type="reset"
                                        className="btn btn-warning pull-right"
                                        value="Cancel"
                                        onClick={onCancelClick}
                                    />
                                </div>
                            </form>
                            <div>
                                <Box minWidth={1050}>
                                    {reportData.length > 0 ? (
                                        <TableContainer component={Paper}>
                                            <Table className={classes.table} size='small' aria-label="simple table" style={{ backgroundSize: '10px' }}>
                                                <TableHead>
                                                    <TableRow >
                                                        <TableCell align="left" style={{ fontWeight: "bold", border: "1px solid black" }}>Date</TableCell>
                                                        <TableCell align="left" style={{ fontWeight: "bold", border: "1px solid black" }}>Route Name</TableCell>
                                                        <TableCell align="left" style={{ fontWeight: "bold", border: "1px solid black" }}>Registration Number</TableCell>
                                                        <TableCell align="left" style={{ fontWeight: "bold", border: "1px solid black" }}>Supplier Name</TableCell>
                                                        <TableCell align="left" style={{ fontWeight: "bold", border: "1px solid black" }}>First Weighment Time</TableCell>
                                                        <TableCell align="left" style={{ fontWeight: "bold", border: "1px solid black" }}>Last Weighment Time</TableCell>
                                                        <TableCell align="right" style={{ fontWeight: "bold", border: "1px solid black" }}>Total</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {reportData.slice(page * limit, page * limit + limit).map((x, i) => (
                                                        <TableRow key={i}>
                                                            <TableCell component="th" scope="row" align="left" style={{ border: "1px solid black" }}> {moment(x.date).format('YYYY-MM-DD')}</TableCell>
                                                            <TableCell component="th" scope="row" align="left" style={{ border: "1px solid black" }}> {x.collectionPointName}</TableCell>
                                                            <TableCell component="th" scope="row" align="left" style={{ border: "1px solid black" }}> {x.registrationNumber}</TableCell>
                                                            <TableCell component="th" scope="row" align="left" style={{ border: "1px solid black" }}> {x.firstName}</TableCell>
                                                            <TableCell component="th" scope="row" align="left" style={{ border: "1px solid black" }}> {(x.startTime)}</TableCell>
                                                            <TableCell component="th" scope="row" align="left" style={{ border: "1px solid black" }}> {(x.endTime)}</TableCell>
                                                            <TableCell component="th" scope="row" align="right" style={{ border: "1px solid black" }}> {(x.totalAmount).toFixed(2)}</TableCell>
                                                        </TableRow>
                                                    ))}
                                                    <TableRow>
                                                        <TableCell colSpan={6} component="th" scope="row" align="left" style={{ border: "1px solid black" }}>Total</TableCell>
                                                        <TableCell component="th" scope="row" align="right" style={{ border: "1px solid black" }}> {(totalAmount).toFixed(2)}</TableCell>
                                                    </TableRow>
                                                </TableBody>
                                            </Table>
                                            <TablePagination
                                                component="div"
                                                count={reportData.length}
                                                onChangePage={handlePageChange}
                                                onChangeRowsPerPage={handleLimitChange}
                                                page={page}
                                                rowsPerPage={limit}
                                                rowsPerPageOptions={[5, 10, 25]}
                                            />
                                        </TableContainer>
                                    ) : null}
                                </Box>
                                {reportData.length > 0 ? (
                                    <div className="pt-4">
                                        <input
                                            type="button"
                                            className="btn btn-primary pull-right ml-2"
                                            value="Excel"
                                            onClick={createFile}
                                        />

                                        <ReactToPrint
                                            documentTitle={"Weighment Details Report"}
                                            trigger={() => <input
                                                type="submit"
                                                className="btn btn-primary pull-right ml-2"
                                                value="PDF"

                                            />}
                                            content={() => componentRef.current}
                                        />
                                    </div>
                                ) : null}
                                <div hidden={true}>
                                    <CreatePdf ref={componentRef} data={reportData} searchData={selectedSearchValues} totalAmount={totalAmount} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}
